import React from 'react'
import './ChatHeader.css'
import { MdSearch } from 'react-icons/md'

function ChatHeader({ channelName }) {
  return (
    <div className='chatHeader'>
      <h3>
        {channelName ? channelName : 'Select or Create a Channel to Begin Messaging'}
      </h3>
    </div>
  )
}

export default ChatHeader